import React, { createContext, useState, useEffect } from 'react';
import axios from 'axios';
import { BASE_URL } from './Api';

const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [token, setToken] = useState(localStorage.getItem('token') || null);
  const [employeeNumber, setEmployeeNumber] = useState(localStorage.getItem('employeeNumber') || null);

  useEffect(() => {
    if (token) {
      axios.defaults.headers.common['Authorization'] = `Bearer ${token}`;
      setIsAuthenticated(true);
    } else {
      delete axios.defaults.headers.common['Authorization'];
      setIsAuthenticated(false);
    }
  }, [token]);

  const login = async (employeeNumber, password) => {
    try {
      const response = await axios.post(`${BASE_URL}/teachers-auth/employee2-auth`, { 
        employeeNumber, 
        password 
      });
      
      // First check if we have a valid response
      if (!response.data.employeeNumber) {
        throw new Error('Invalid response from server');
      }

      // Set local storage first
      localStorage.setItem('employeeNumber', employeeNumber);
      setEmployeeNumber(employeeNumber);
      setIsAuthenticated(true);

      return response.data;
    } catch (error) {
      console.error('Login error:', error);
      // Clear any partial auth state
      localStorage.removeItem('employeeNumber');
      setEmployeeNumber(null);
      setIsAuthenticated(false);
      
      throw error;
    }
  };

  const logout = () => {
    localStorage.removeItem('token');
    localStorage.removeItem('employeeNumber'); 
    setToken(null);
    setEmployeeNumber(null); 
    setIsAuthenticated(false);
  };

  return (
    <AuthContext.Provider value={{ isAuthenticated, employeeNumber, login, logout }}>
      {children}
    </AuthContext.Provider>
  );
};

export default AuthContext;
